export const isTextInputElement = (element: Element | null) => {
  if (!(element instanceof HTMLElement)) {
    return false;
  }

  const tag = element.tagName.toLowerCase();
  if (tag === 'textarea') {
    return true;
  }

  if (tag === 'input') {
    const input = element as HTMLInputElement;
    const textLikeTypes = new Set([
      'text',
      'email',
      'tel',
      'url',
      'search',
      'password',
      'number',
    ]);
    return textLikeTypes.has((input.type || 'text').toLowerCase());
  }

  if (element.getAttribute('contenteditable') === 'true') {
    return true;
  }

  return false;
};

